import { ErrorToast } from "../index";
import Urls from "../../api/endpoints";
import Form from "react-bootstrap/Form";
import InputMask from "react-input-mask";
import Modal from "react-bootstrap/Modal";
import FormTexts from "../../constants/forms";
import Headings from "../../constants/headings";
import Dropdown from "react-bootstrap/Dropdown";
import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import {
  NationalCodeSeparator,
  DateToPersianNumber,
  ErrorHandling,
  ErrorHandlingAPI,
  toEnglishNumber,
} from "../../functions/index";
import {
  formsLabelType,
  formsPlaceHolderType,
  formsButtonType,
  NidRejectReasonType,
  ModalContentType,
  ProductType,
  DiscountCodeProductLimit,
  DiscountCodePurchaseLimit,
} from "../../enums/index";
import { getDiscountSRV } from "../../api/requestAxios/discounts";
import DrpList from "../../functions/extensions/drpList/drpList";
import { SelectCheckBox } from "../../assets/images/svg/selectCheckBox";
import { UnSelectCheckbox } from "../../assets/images/svg/unSelectCheckbox";
import { SelectedRadio } from "../../assets/images/svg/SelectedRadio";
import { UnSelectedRadio } from "../../assets/images/svg/unselectedRadio";
import jalaliToGregorian from "../../functions/extensions/jalaliToGregorian";


function ModalContainer(props) {
  const [selectedCheckBox, setSelectedCheckBox] = useState(3);
  const [checkBoxServiceType, setCheckBoxServiceType] = useState(
    DiscountCodeProductLimit.AllProducts()
  );
  const [checkBoxCustomerType, setCheckBoxCustomerType] = useState(
    DiscountCodePurchaseLimit.AllPurchasesAllowed()
  );
  const [checkBoxPackageType, setCheckBoxPackageType] = useState([0, 0, 0, 0]);
  const [rejectCheckBox, setRejectCheckBox] = useState(
    props.type === ModalContentType.RejectUser()
      ? props.data.selectedRejectCheckBox.current
      : NidRejectReasonType.None()
  );
  const [sendSmsButton, setSendSmsButton] = useState(true);
  const [reasonButton, setReasonButton] = useState(true);
  const [rejectActivatedButton, setRejectActivatedButton] = useState(true);
  const [productPackageTitle, setProductPackageTitle] = useState("انتخاب بسته");
  const [productPackages, setProductPackages] = useState([]);
  const [productSelect, setProductSelect] = useState([]);
  const [loadingProductPackages, setLoadingProductPackages] = useState(false)

  const [coupon, setCoupon] = useState({
    allProductTypes: true,
    productLimitation: [],
    purchaseLimit: [1],
    contractTypeLimit: [1],
    code: null,
    applicationLimitCount: null,
    discountPercent: 0,
    maxDiscountAmount: null,
    persianStartDate: "",
    persianEndDate: "",

  })



  useEffect(() => {
    setCheckBoxPackageType([0, 0, 0, 0])
    setProductPackageTitle([])
  }, [props])


  function today() {
    var today = new Date();
    today.setDate(today.getDate() + 0);
    return today;
  }
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const changeServiceType = (pLimitCode, pCode, title, pTitle) => {
    setCheckBoxServiceType(pLimitCode);
    if (pCode) getProductType(pCode);
    if (pTitle) setProductPackageTitle(pTitle);
  };

  const changeCouponStateByKey = (prop, value) => {
    if (value && value !== "") {
      props.coupon[prop] = value;
      props.setCoupon({ ...props?.coupon });
    } else {
      switch (prop) {
        case "discountPercent":
          props.coupon[prop] = 0;
          props.setCoupon({ ...props?.coupon });
          break;
        case "persianStartDate":
          props.coupon[prop] = toEnglishNumber(new Date().toLocaleDateString("fa-IR", {
            month: '2-digit', day: '2-digit', year: 'numeric'
          }));
          props.setCoupon({ ...props?.coupon });
          break;
        case "persianEndDate":
          props.coupon[prop] = toEnglishNumber(addDays(today(), 88).toLocaleDateString("fa-IR", {
            month: '2-digit', day: '2-digit', year: 'numeric'
          }))
          props.setCoupon({ ...props?.coupon });
          break;
        default:
          props.coupon[prop] = null;
          props.setCoupon({ ...props?.coupon });
          break;
      }
    }
  };

  const getProductType = async (productType) => {
    setLoadingProductPackages(true)
    try {
      const data = await getDiscountSRV(productType)
      setLoadingProductPackages(false)
      if (data?.data) {
        let temp = [...productPackages]
        temp.push({ productType, products: data.data })
        setProductPackages(temp);
      }
    }
    catch (err) {
      setLoadingProductPackages(false)
      ErrorToast(err)
    }


  };

  useEffect(() => {
    setRejectCheckBox(
      props.type === 5
        ? props.data.selectedRejectCheckBox.current
        : NidRejectReasonType.None()
    );
    setReasonButton(true);
  }, [props]);


  const setProductLimit = (type, index) => {
    let temp = { ...props.coupon }
    if (type !== 0) {
      temp.allProductTypes = false
      if (props.coupon?.productLimitation?.some(x => x?.productType === type)) temp.productLimitation = temp?.productLimitation.filter(x => x?.productType !== type)
      else {
        temp.productLimitation.push({
          productType: type,
          allProducts: true,
          productIds: []

        })
      }
    }
    else {
      temp.allProductTypes = !temp.allProductTypes
      temp.productLimitation = []
    }
    props.setCoupon({ ...temp })
  }

  const setPurchaseLimit = (type) => {
    let temp = { ...props.coupon }
    if (type !== 1) {
      if (props.coupon?.purchaseLimit?.some(x => x === 1)) temp.purchaseLimit = temp?.purchaseLimit.filter(x => x !== 1)
      if (props.coupon?.purchaseLimit?.some(x => x === type)) temp.purchaseLimit = temp?.purchaseLimit.filter(x => x !== type)
      else temp.purchaseLimit.push(type)
    }
    else {
      if (props.coupon?.purchaseLimit?.some(x => x !== 1)) temp.purchaseLimit = []
      else temp.purchaseLimit.push(1)
    }
    props.setCoupon({ ...temp })
  }


  const setContractTypeLimit = (type) => {
    let temp = { ...props.coupon }
    if (type !== 1) {
      if (props.coupon?.contractTypeLimit?.some(x => x === 1)) temp.contractTypeLimit = temp?.contractTypeLimit.filter(x => x !== 1)
      if (props.coupon?.contractTypeLimit?.some(x => x === type)) temp.contractTypeLimit = temp?.contractTypeLimit.filter(x => x !== type)
      else temp.contractTypeLimit.push(type)
    }
    else {
      if (props.coupon?.contractTypeLimit?.some(x => x !== 1)) temp.contractTypeLimit = []
      else temp.contractTypeLimit.push(1)
    }
    props.setCoupon({ ...temp })
  }

  const settingAllProducts = (index, type, value) => {
    let temp = { ...props.coupon }
    if (value === 0) {
      temp.productLimitation[index].allProducts = true
      temp.productLimitation[index].productIds = []
    }
    else {
      temp.productLimitation[index].allProducts = false
      if (!productPackages.some(x => x.productType === type)) {
        getProductType(type)
      }

    }
    props.setCoupon({ ...temp })

  }


  const differenceInDays = (startDate, endDate) => {
    let startDateSplitted = startDate.split('/')
    let endDateSplitted = endDate.split('/')

    let jDStartDate = jalaliToGregorian(startDateSplitted[0], startDateSplitted[1], startDateSplitted[2]);
    let jDEndDate = jalaliToGregorian(endDateSplitted[0], endDateSplitted[1], endDateSplitted[2]);

    let jDStartDateStr = jDStartDate[0] + "-" + jDStartDate[1] + "-" + jDStartDate[2]
    let jDEndDateStr = jDEndDate[0] + "-" + jDEndDate[1] + "-" + jDEndDate[2]

    let DifferenceInTime = new Date(jDEndDateStr).getTime() - new Date(jDStartDateStr).getTime();
    let DifferenceInDaysTemp = Math.round(DifferenceInTime / (1000 * 3600 * 24));

    return DifferenceInDaysTemp
  }


  return (
    <Modal show={props.show} onHide={props.handleClose} animation={true} className="custom-modal">
      <Modal.Header>
        <Modal.Title>
          {props.title}
          <img
            onClick={props.handleClose}
            src={btnClose}
            alt={props.title}
            className="btn-close"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.type === ModalContentType.SendSms() ? (
          <Form className="text-center">
            <Row className="mb-2">
              <Form.Group as={Col} className="d-flex justify-content-center">
                <Form.Control
                  className="normal-input direction-rtl"
                  type="text"
                  rows={5}
                  as="textarea"
                  placeholder={FormTexts.PlaceHolders(
                    formsPlaceHolderType.SendSms()
                  )}
                  onChange={(e) => {
                    props.data.current = e.target.value;
                    if (e.target.value !== "") {
                      setSendSmsButton(false);
                    } else {
                      setSendSmsButton(true);
                    }
                  }}
                />
              </Form.Group>
            </Row>
            <Button
              className="submit-button big lines-button"
              variant="primary"
              disabled={sendSmsButton}
              onClick={(e) => props.handleClose(e, true)}
            >
              {FormTexts.Buttons(formsButtonType.SendSms())}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === 2 ? (
          <Form>
            <div className="mb-3 round-container">
              <Form.Check
                inline
                label="welcome"
                className="round"
                type="radio"
                checked={selectedCheckBox === 0 ? true : false}
                onChange={() => {
                  setSelectedCheckBox(0);
                }}
              />
              <Form.Check
                inline
                label="reset password"
                className="round"
                type="radio"
                checked={selectedCheckBox === 1 ? true : false}
                onChange={() => {
                  setSelectedCheckBox(1);
                }}
              />
            </div>
            <div className="mb-3 round-container">
              <Form.Check
                inline
                label="template one"
                className="round"
                type="radio"
                checked={selectedCheckBox === 2 ? true : false}
                onChange={() => {
                  setSelectedCheckBox(2);
                }}
              />
              <Form.Check
                inline
                label="template two"
                className="round"
                type="radio"
                checked={selectedCheckBox === 3 ? true : false}
                onChange={() => {
                  setSelectedCheckBox(3);
                }}
              />
            </div>
            <Button type="submit" className="mb-2">
              send
            </Button>
          </Form>
        ) : props.type === ModalContentType.AuthHistory() ? (
          props.data && (
            <div className="modal-detail-form">
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label detail-text-box-label">
                    {FormTexts.Labels(formsLabelType.NationalCode())}:
                  </Form.Label>
                  <span className="detail-text-box dir-ltr">
                    {NationalCodeSeparator(props.data.NationalCode)}
                  </span>
                </Form.Group>
              </Row>
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label detail-text-box-label">
                    {FormTexts.Labels(formsLabelType.Name())}:
                  </Form.Label>
                  <span className="detail-text-box">
                    {props.data.FirstName}
                  </span>
                </Form.Group>
              </Row>
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label detail-text-box-label">
                    {FormTexts.Labels(formsLabelType.Family())}:
                  </Form.Label>
                  <span className="detail-text-box">{props.data.LastName}</span>
                </Form.Group>
              </Row>
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label detail-text-box-label">
                    {FormTexts.Labels(formsLabelType.BirthDay())}:
                  </Form.Label>
                  <span className="detail-text-box">
                    {DateToPersianNumber(props.data.BirthDate)}
                  </span>
                </Form.Group>
              </Row>
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label detail-text-box-label">
                    {FormTexts.Labels(formsLabelType.FatherName())}:
                  </Form.Label>
                  <span className="detail-text-box">
                    {props.data.FatherName}
                  </span>
                </Form.Group>
              </Row>
            </div>
          )
        ) : props.type === 4 || props.type === 11 ? (
          <Form className="text-center">
            <br />
            <br />
            {props.data.current}
            <br />
            <br />
            <Button
              className="submit-button big lines-button"
              variant="primary"
              onClick={(e) => props.handleClose(e, true)}
            >
              {Headings.LinesTableHeading[7]}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === ModalContentType.RejectUser() ? (
          <Form className="text-center">
            <div className="mb-3 round-container">
              <Form.Check
                inline
                label={FormTexts.Labels(formsLabelType.RejectAuthNational())}
                className="round"
                type="radio"
                checked={
                  rejectCheckBox ===
                    NidRejectReasonType.NationalCardNotAppropriate()
                    ? true
                    : false
                }
                onChange={() => {
                  props.data.reason.current = "";
                  props.data.reasonCode.current =
                    NidRejectReasonType.NationalCardNotAppropriate();
                  setRejectCheckBox(
                    NidRejectReasonType.NationalCardNotAppropriate()
                  );
                  setReasonButton(false);
                }}
              />
            </div>
            <div className="mb-3 round-container">
              <Form.Check
                inline
                label={FormTexts.Labels(formsLabelType.RejectAuthPostal())}
                className="round"
                type="radio"
                checked={
                  rejectCheckBox === NidRejectReasonType.AddressNotValid()
                    ? true
                    : false
                }
                onChange={() => {
                  props.data.reason.current = "";
                  props.data.reasonCode.current =
                    NidRejectReasonType.AddressNotValid();
                  setRejectCheckBox(NidRejectReasonType.AddressNotValid());
                  setReasonButton(false);
                }}
              />
            </div>
            <div className="mb-3 round-container">
              <Form.Check
                inline
                label={FormTexts.Labels(formsLabelType.RejectAuthOther())}
                className="round"
                type="radio"
                checked={
                  rejectCheckBox === NidRejectReasonType.Others() ? true : false
                }
                onChange={() => {
                  props.data.reasonCode.current = NidRejectReasonType.Others();
                  setRejectCheckBox(NidRejectReasonType.Others());
                  setReasonButton(true);
                }}
              />
            </div>
            {rejectCheckBox === NidRejectReasonType.Others() && (
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Control
                    className="normal-input direction-rtl"
                    type="text"
                    rows={5}
                    as="textarea"
                    placeholder={FormTexts.PlaceHolders(
                      formsPlaceHolderType.Reason()
                    )}
                    onChange={(e) => {
                      props.data.reason.current = e.target.value;
                      props.data.reasonCode.current =
                        NidRejectReasonType.Others();
                      if (e.target.value !== "") {
                        setReasonButton(false);
                      } else {
                        setReasonButton(true);
                      }
                    }}
                  />
                </Form.Group>
              </Row>
            )}

            <Button
              className="submit-button big lines-button"
              variant="primary"
              disabled={reasonButton}
              onClick={(e) => props.handleClose(e, true)}
            >
              {FormTexts.Buttons(formsButtonType.Reject())}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === ModalContentType.RejectLine() ? (
          <Form className="text-center">
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  className="normal-input direction-rtl"
                  type="text"
                  rows={5}
                  as="textarea"
                  placeholder={FormTexts.PlaceHolders(
                    formsPlaceHolderType.RejectActivation()
                  )}
                  onChange={(e) => {
                    props.data.current = e.target.value;
                    if (e.target.value !== "") {
                      setRejectActivatedButton(false);
                    } else {
                      setRejectActivatedButton(true);
                    }
                  }}
                />
              </Form.Group>
            </Row>
            <Button
              className="submit-button big lines-button"
              variant="primary"
              disabled={rejectActivatedButton}
              onClick={(e) => props.handleClose(e, true)}
            >
              {FormTexts.Buttons(formsButtonType.RejectActivation())}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === ModalContentType.Coupon() ? (
          <Form className="coupon-modal">
            <div>
              <h1>نوع سرویس</h1>
              <div className="mb-3 round-container rtl">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-start">
                    <span className="select-unselect-span" onClick={() => setProductLimit(0, 0)}>{props.coupon?.allProductTypes ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                    <label>همه سرویس‌ها</label>
                  </div>
                  <div className="d-flex justify-content-start">
                    <span className="select-unselect-span" onClick={() => setProductLimit(2, 1)}>{props.coupon?.productLimitation?.some(x => x?.productType === 2) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                    <label>سرویس تلفن گویا</label>
                  </div>
                  <div className="d-flex justify-content-start">
                    <span className="select-unselect-span" onClick={() => setProductLimit(1, 2)}>{props.coupon?.productLimitation?.some(x => x?.productType === 1) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                    <label>سرویس منشی مجازی</label>

                  </div>
                  <div className="d-flex justify-content-start">
                    <span className="select-unselect-span" onClick={() => setProductLimit(4, 3)}>{props.coupon?.productLimitation?.some(x => x?.productType === 4) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                    <label>سرویس فکس اینترنتی</label>

                  </div>
                  <div className="d-flex justify-content-start">
                    <span className="select-unselect-span" onClick={() => setProductLimit(3, 4)}>{props.coupon?.productLimitation?.some(x => x?.productType === 3) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                    <label>خط</label>
                  </div>

                </div>
              </div>
            </div>
            <div>
              {
                !props.coupon?.productLimitation?.some(x => x === 1) && props.coupon?.productLimitation?.map((item, index) =>
                  <>
                    <h1>نوع بسته
                      {item?.productType === 2 && <span> تلفن گویا </span>}
                      {item?.productType === 1 && <span>  منشی مجازی </span>}
                      {item?.productType === 4 && <span> فکس </span>}
                      {item?.productType === 3 && <span> خط </span>}
                    </h1>
                    <div className="mb-3 round-container rtl">
                      <div className="d-flex justify-content-start   align-items-center" style={{ width: '110%' }}>
                        <div className="d-flex justify-content-between  m-2">
                          <span className="select-unselect-span " onClick={() => settingAllProducts(index, item?.productType, 0)}>{item?.allProducts ? <SelectedRadio /> : <UnSelectedRadio />}</span>
                          <label>همه </label>
                        </div>
                        <div className="d-flex justify-content-between  m-2">
                          <span className="select-unselect-span" onClick={() => settingAllProducts(index, item?.productType, 1)}>{!item?.allProducts ? <SelectedRadio /> : <UnSelectedRadio />}</span>
                          <label>بسته‌ی خاص</label>
                        </div>
                        {!item?.allProducts &&
                          <DrpList
                            list={productPackages}
                            setSelectedList={props.setCoupon}
                            isShowOrder={true}
                            selectedList={props.coupon?.productLimitation}
                            type={item?.productType}
                            index={index}
                            coupon={props.coupon}
                            loadingProductPackages={loadingProductPackages}

                          />
                        }
                      </div>
                    </div>
                  </>
                )}
            </div>
            <h1>نوع مشترکین</h1>
            <div className="mb-3 round-container rtl">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setPurchaseLimit(1)}>{props.coupon?.purchaseLimit?.some(x => x === 1) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>همه مشترکین</label>
                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setPurchaseLimit(2)}>{props.coupon?.purchaseLimit?.some(x => x === 2) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>اولین خرید</label>
                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setPurchaseLimit(3)}>{props.coupon?.purchaseLimit?.some(x => x === 3) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>تمدید سرویس</label>

                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setPurchaseLimit(4)}>{props.coupon?.purchaseLimit?.some(x => x === 4) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>مشترکین بازگشتی</label>
                </div>
              </div>
            </div>


            <h1>نوع قرارداد</h1>
            <div className="mb-3 round-container rtl">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setContractTypeLimit(1)}>{props.coupon?.contractTypeLimit?.some(x => x === 1) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>همه</label>
                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setContractTypeLimit(2)}>{props.coupon?.contractTypeLimit?.some(x => x === 2) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label> یک ماهه</label>
                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setContractTypeLimit(3)}>{props.coupon?.contractTypeLimit?.some(x => x === 3) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>سه ماهه</label>

                </div>
                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setContractTypeLimit(4)}>{props.coupon?.contractTypeLimit?.some(x => x === 4) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>شش ماهه</label>
                </div>

                <div className="d-flex justify-content-start">
                  <span className="select-unselect-span" onClick={() => setContractTypeLimit(5)}>{props.coupon?.contractTypeLimit?.some(x => x === 5) ? <SelectCheckBox /> : <UnSelectCheckbox />}</span>
                  <label>یک ساله</label>
                </div>
              </div>
            </div>


            <div>
              <h1>مشخصات کد</h1>
              <Row className="mb-2">
                <Form.Group as={Col}>
                  <Form.Label className="input-label">کد:</Form.Label>
                  <Form.Control
                    className="normal-input"
                    type="text"
                    onChange={(e) => {
                      changeCouponStateByKey("code", e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label className="input-label">سقف تعداد:</Form.Label>
                  <Form.Control
                    className="normal-input"
                    type="number"
                    placeholder="نامحدود"
                    onChange={(e) => {
                      changeCouponStateByKey(
                        "applicationLimitCount",
                        e.target.value
                      );
                    }}
                  />
                </Form.Group>
              </Row>
              <Row className="mb-2">
                {" "}
                <Form.Group as={Col}>
                  <Form.Label className="input-label birthday-input-label">
                    تاریخ ایجاد:
                  </Form.Label>
                  <InputMask
                    mask="9999/99/99"
                    placeholder={new Date().toLocaleDateString("fa-IR", {
                      month: '2-digit', day: '2-digit', year: 'numeric'
                    })}
                    className="normal-input from-control birthday-input"
                    type="text"
                    onChange={(e) => {
                      changeCouponStateByKey(
                        "persianStartDate",
                        e.target.value
                      );
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label className="input-label birthday-input-label">
                    تاریخ انقضا:
                  </Form.Label>
                  <InputMask
                    mask="9999/99/99"
                    placeholder={addDays(today(), 88).toLocaleDateString("fa-IR", {
                      month: '2-digit', day: '2-digit', year: 'numeric'
                    })}
                    className="normal-input from-control birthday-input"
                    type="text"
                    onChange={(e) => {
                      changeCouponStateByKey("persianEndDate", e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row className="mb-2">
                {" "}
                <Form.Group as={Col}>
                  <Form.Label className="input-label">درصد:</Form.Label>
                  <Form.Control
                    className="normal-input"
                    type="number"
                    placeholder="0"
                    onChange={(e) => {
                      changeCouponStateByKey("discountPercent", e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label className="input-label">
                    سقف مبلغ(تومان):
                  </Form.Label>
                  <Form.Control
                    className="normal-input"
                    type="number"
                    placeholder="نامحدود"
                    onChange={(e) => {
                      changeCouponStateByKey(
                        "maxDiscountAmount",
                        e.target.value
                      );
                    }}
                  />
                </Form.Group>
              </Row>
            </div>
            <div className="text-center mt-5">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  let diffDays = differenceInDays(props.coupon.persianStartDate, props.coupon.persianEndDate)
                  if (diffDays > 90) {
                    ErrorToast(
                      "امکان تعریف کد تخفیف با اعتبار زمانی بیش از ۹۰ روز وجود ندارد!"
                    );
                  } else {
                    props.data.coupon.current = props.coupon;
                    props.handleClose(e, true);
                  }
                }}
                disabled={
                  props.coupon.code === null || props.coupon.code === "" || props.coupon?.contractTypeLimit?.length === 0 || (!props.coupon?.allProductTypes && props.coupon?.productLimitation?.length === 0) || props.coupon?.purchaseLimit?.length === 0 ? true : false
                }
                className="mb-2"
              >
                ذخیره
              </Button>
            </div>
          </Form>
        ) : props.type === ModalContentType.EnableCoupon() ? (
          <Form className="text-center">
            <br />
            <br />
            {props.data.content}
            <br />
            <br />
            <Button
              className="submit-button big lines-button"
              variant="primary"
              onClick={(e) =>
                props.handleClose(e, true, ModalContentType.EnableCoupon())
              }
            >
              {props.data.btn}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === ModalContentType.DisableCoupon() ? (
          <Form className="text-center">
            <br />
            <br />
            {props.data.content}
            <br />
            <br />
            <Button
              className="submit-button big lines-button"
              variant="primary"
              onClick={(e) =>
                props.handleClose(e, true, ModalContentType.DisableCoupon())
              }
            >
              {props.data.btn}
            </Button>
            <br />
            <br />
          </Form>
        ) : props.type === ModalContentType.ExtendCoupon() ? (
          <Form className="text-center coupon-modal">
            <br />
            <br />
            <InputMask
              mask="9999/99/99"
              placeholder={toEnglishNumber(addDays(today(), 88).toLocaleDateString("fa-IR", {
                month: '2-digit', day: '2-digit', year: 'numeric'
              }))}
              className="normal-input from-control birthday-input"
              type="text"
              onChange={(e) => {
                props.extendDate.current = e.target.value;
              }}
            />
            <br />
            <br />
            <Button
              className="submit-button big lines-button"
              variant="primary"
              onClick={(e) => {
                props.handleClose(e, true, ModalContentType.ExtendCoupon());
              }}
            >
              {props.data.btn}
            </Button>
            <br />
            <br />
          </Form>
        ) : (
          <></>
        )}
      </Modal.Body>
    </Modal >
  );
}
export default ModalContainer;
